/**
 * Check External EDGE data should be plot on left or right ladder.
 * @param {boolean} isLeft
 * @param {string} accessedRoleLevelUpperCase
 * @param {string} currentRoleLevel
 * @returns {boolean} TRUE if the EDGE data should be at the left ladder.
 */
export function isExternalDotAtLeftOrRightLadder(isLeft, accessedRoleLevelUpperCase, currentRoleLevel) {
  const assessedRole = getSpecialRole(accessedRoleLevelUpperCase);
  if (assessedRole === null || assessedRole === undefined) {
    return isLeft;
  }

  const currentRole = getRole(currentRoleLevel).role;
  console.log(`Special handling for assessedRoleLevel triggered. AssessRole=[${assessedRole}] CurrentRole=[${currentRole}].`);

  if (assessedRole === currentRole) {
    return true;
  }
  return false;

  function getSpecialRole(accessedRole) {
    const specialRoles = ['SGM 1', 'SGM 2', 'SDL 3'];

    return specialRoles.find((specialRole) => {
      if (accessedRole.indexOf(specialRole) !== -1) {
        return true;
      }

      return false;
    });
  }

  function getRole(role) {
    const sgmRoles = [
      { role: 'SGM 1', rank: 'P11' },
      { role: 'SGM 2', rank: 'P12' },
    ];

    let foundRole = sgmRoles.find((sgmRole) => {
      if (role.indexOf(sgmRole.rank) !== -1) {
        return true;
      }

      return false;
    });

    if (!foundRole) {
      foundRole = sgmRoles[0];
    }
    return foundRole;
  }
}
